export const ENTITIES = {
  HOME: 'home',
  GAME: 'game',
  BATTLE: 'battle',
  HOW_TO_PLAY: 'howToPlay',
  LOGIN: 'login',
};
